import * as Yup from 'yup'

const CancelTrainerPlanFormValidations = () => {
    return Yup.object().shape({
    })
}

export { CancelTrainerPlanFormValidations }